import { ICruise } from './interfaces'

export const useState = (): CatalogState => {
  return {
    cruises: [],
    totalResults: 0,
    loadingNextPageInProgress: false,
    pageNumber: 1,
    requestId: ''
  }
}

export interface CatalogState {
  cruises: ICruise[]
  totalResults: number
  loadingNextPageInProgress: boolean
  pageNumber: number
  requestId: string
}